module.exports = __webpack_public_path__ + "static/media/racivid2.312a7d98.png";